import React, { useEffect } from "react";
import Box from "@material-ui/core/Box";
import { Container } from "@prestosports/commons-ui";
import GameHeader from "../components/GameHeader";
import commonStyles from "../../common/styles/Common.styles";
import { useGameContextContext } from "../../../state/game-context/context";
import GameFinalize from "../components/GameFinalize";
import { useMatchesContext } from "../../../state/matches/context";
import { useEventContext } from "../../../state/events/context";
import { GameRoutes } from "../../../routes/game-routes";
import { useAppContext } from "../../../state/app/context";

const GameFinalizeContainer = () => {
	const commonClasses = commonStyles();
	const { state: events } = useEventContext();
	const currentEvent = events.currentEvent();
	const { gameConfiguration } = events.currentEventSettings() || {};

	const { state, getMatches } = useMatchesContext();
	const singles = state.singles();
	const doubles = state.doubles();
	const totals = state.totals();

	const {
		state: gameContextState,
		finalizeGame,
		saveMatchesFinalizationOrder,
		saveFinalizationSettings
	} = useGameContextContext();
	const finalizeSettings = gameContextState.finalizeSettings();

	const { redirect } = useAppContext();

	useEffect(() => {
		if (currentEvent) {
			getMatches(currentEvent.id);
		}
	}, [currentEvent]);

	const cancelHandler = () => {
		redirect(GameRoutes.GAME_MODE.url.replace(":eventId", currentEvent.id));
	};

	const changeMatchesOrderHandler = (isSingles, newOrder) => {
		const orderedIds = newOrder.map((m) => m.id);
		saveMatchesFinalizationOrder(isSingles, orderedIds);
	};

	return (
		<>
			<GameHeader
				title="Finalize Event"
				description="Enter the final details of the event."
			/>
			<Box className={commonClasses.infoContainer}>
				{currentEvent && (
					<Container fullHeight>
						<GameFinalize
							singles={singles}
							doubles={doubles}
							totals={totals}
							settings={finalizeSettings}
							gameConfiguration={gameConfiguration}
							event={currentEvent}
							onFinalize={finalizeGame}
							onSave={saveFinalizationSettings}
							onCancel={cancelHandler}
							onChangeMatchesOrder={changeMatchesOrderHandler}
						/>
					</Container>
				)}
			</Box>
		</>
	);
};

export default GameFinalizeContainer;
